<template>
  <section class="plan-container">
    <spinner v-if="showSpinner" fullScreen />
    <form style="max-width: 400px;">
      <b-form-group
        horizontal
        v-if="!campaign.type"
        :label-cols="7"
        id="newRequestPrice"
        label="Price per New Request"
        label-for="newRequestPrice">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <input
            id="newRequestPrice"
            type="number"
            v-model="plan.newRequest"
            :disabled="!isAdmin"
            placeholder="Enter amount"
            class="form-control"
          />
        </div>
      </b-form-group>
      <b-form-group
        v-if="!campaign.type"
        horizontal
        :label-cols="7"
        id="dataPointPrice"
        label="Price per Data Point"
        label-for="dataPointPrice">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <input
            id="dataPointPrice"
            type="number"
            v-model="plan.dataPoint"
            :disabled="!isAdmin"
            placeholder="Enter amount"
            class="form-control"
          />
        </div>
      </b-form-group>
      <b-form-group
        v-if="!campaign.type"
        horizontal
        :label-cols="7"
        id="notesPrice"
        label="Price per Notes"
        label-for="notesPrice">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <input
            id="notesPrice"
            type="number"
            v-model="plan.notes"
            :disabled="!isAdmin"
            placeholder="Enter amount"
            class="form-control"
          />
        </div>
      </b-form-group>
      <b-form-group
        horizontal
        v-if="!campaign.type"
        :label-cols="7"
        id="completedLeadPrice"
        label="Price per Completed Lead"
        label-for="completedLeadPrice">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <input
            id="completedLeadPrice"
            type="number"
            v-model="plan.lead"
            :disabled="!isAdmin"
            placeholder="Enter amount"
            class="form-control"
          />
        </div>
      </b-form-group>
      <b-form-group
        horizontal
        v-if="!campaign.type"
        :label-cols="7"
        id="partialLeadPrice"
        label="Price per Partial Lead"
        label-for="partialLeadPrice">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <input
            id="partialLeadPrice"
            type="number"
            v-model="plan.partialLead"
            :disabled="!isAdmin"
            placeholder="Enter amount"
            class="form-control"
          />
        </div>
      </b-form-group>
      <b-form-group
        horizontal
        v-if="campaign.type === 'shopify'"
        :label-cols="7"
        id="orderAmount"
        label="Price per Order"
        label-for="orderAmount">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">$</span>
          </div>
          <input
            id="orderAmount"
            type="number"
            v-model="plan.orderAmount"
            :disabled="!isAdmin"
            placeholder="Enter amount"
            class="form-control"
          />
        </div>
      </b-form-group>
      <b-form-group
        horizontal
        v-if="campaign.type === 'shopify'"
        :label-cols="7"
        id="orderPercent"
        label="Percent per Order"
        label-for="orderPercent">
        <div class="input-group">
          <div class="input-group-prepend">
            <span class="input-group-text">%</span>
          </div>
          <input
            id="orderPercent"
            type="number"
            v-model="plan.orderPercent"
            :disabled="!isAdmin"
            placeholder="Enter percent"
            class="form-control"
          />
        </div>
      </b-form-group>
      <b-form-group>
        <div class="">
          <button
            type="button"
            v-if="isAdmin"
            @click="update"
            class="btn btn-info text-right">
            Save
          </button>
        </div>
      </b-form-group>
    </form>
  </section>
</template>
<script>
import { mapGetters } from 'vuex';
import PLAN from '@/graphql/Campaigns/CampaignPlan.gql';
import EDIT_PLAN from '@/graphql/Campaigns/EditCampaignPlan.gql';


export default {
  props: {
    campaignId: Number,
  },
  computed: {
    ...mapGetters(['getAuthUser', 'isUserAdmin', 'campaign']),
    isAdmin() {
      return this.isUserAdmin;
    },
  },
  data() {
    return {
      plan: {},
      showSpinner: false,
    };
  },
  methods: {
    async update() {
      try {
        const input = {
          newRequest: Number(this.plan.newRequest),
          dataPoint: Number(this.plan.dataPoint),
          notes: Number(this.plan.notes),
          lead: Number(this.plan.lead),
          partialLead: Number(this.plan.partialLead),
          orderAmount: Number(this.plan.orderAmount),
          orderPercent: Number(this.plan.orderPercent),
        };
        await this.$apollo.mutate({
          mutation: EDIT_PLAN,
          variables: {
            id: this.campaignId,
            input
          }
        });
        this.$notify({
          group: 'success',
          type: 'success',
          text: 'Saved',
        });
      } catch (e) {
        this.$notify({
          group: 'error',
          type: 'error',
          text: e.message,
        });
      }
    },
  },
  apollo: {
    campaignPlan: {
      query: PLAN,
      loadingKey: 'showSpinner',
      fetchPolicy: 'network-only',
      variables() {
        return {
          id: this.campaignId
        };
      },
      result({ data, loading }) {
        if (loading) {
          return;
        }
        this.plan = (data.campaignPlan) ? data.campaignPlan : {};
      },
    },
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/Campaigns/Details/Plan.vue